import React, { PureComponent } from "react";

let clickMove = false;
let mousedown = false;

export default class ClickMove extends PureComponent {
  handleMouseDown = () => {
    mousedown = true;
  };
  handleMouseMove = () => {
    if (mousedown) {
      const oldClickMove = clickMove;
      clickMove = true;
      if (!oldClickMove) this.props.onClickMove(true);
    }
  };
  handleMouseOut = () => {
    const oldClickMove = clickMove;
    clickMove = false;
    mousedown = false;
    if (oldClickMove) this.props.onClickMove(false);
  };
  render() {
    return (
      <div
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseLeave={this.handleMouseOut}
        onMouseUp={this.handleMouseOut}
      >
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClickMove.js